module.exports = __webpack_public_path__ + "static/media/zm.38742fa2.svg";